import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnLR: CultureInfo = {
  name: 'en-LR',
  displayName: 'English (Liberia)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-LR',
  parent: CultureInfoEn
};
